/* system capability */
export const SYSTEM_CAPABILITY = {
  None: 0,
  Read: 1,
  Write: 2,
  Delete: 4,
  Query: 8,
  NextPage: 16,
  Pagination: 32,
  Projection: 64,
  CombinedQuery: 128,
  Workflow: 256,
  Sort: 512,
  AddInformation: 1024,
  ChangeInformation: 2048,
};
/**
 * 
 * @param {Number} type 
 * @param {Array} modules 
 * @param {Number || String} moduleId 
 * @returns {Boolean}
 */
export const isCapableOf = (type, modules, moduleId) => {
  const module = modules.find(x => x.id == moduleId);
  return module && module.connectorCapability !== null && module.connectorCapability !== undefined ?
    (module.connectorCapability & type) === type : true;
}
/* information */
export const Information = {
  Text: {
    ID: 0,
    Type: 'text',
    Name: 'Text',
    Icon: 'fts-icon-text',
    Hint: 'alphabets, numbers, symbols and spaces in single line'
  },
  MultilineText: {
    ID: 16,
    Type: 'multiline-text',
    Name: 'Multiline Text',
    Icon: 'fts-icon-text-area',
    Hint: 'plain text such as words, sentences or paragraph with new lines'
  },
  YesNo: {
    ID: 1,
    Type: 'yes-no',
    Name: 'Yes No',
    Icon: 'fts-icon-check-square',
    Hint: 'yes or no, true or false'
  },
  Integer: {
    ID: 2,
    Type: 'integer',
    Name: 'Integer',
    Icon: 'fts-icon-integer',
    Hint: 'whole number without decimals'
  },
  Number: {
    ID: 3,
    Type: 'number',
    Name: 'Number',
    Icon: 'fts-icon-number',
    Hint: 'numbers with decimal points'
  },
  Money: {
    ID: 4,
    Type: 'money',
    Name: 'Money',
    Icon: 'fts-icon-dollar-sign',
    Hint: 'currency'
  },
  Date: {
    ID: 5,
    Type: 'date',
    Name: 'Date',
    Icon: 'fts-icon-calendar',
    Hint: 'calendar date'
  },
  DateTime: {
    ID: 6,
    Type: 'date-time',
    Name: 'Date Time',
    Icon: 'fts-icon-calendar',
    Hint: 'calendar date with time'
  },
  Module: {
    ID: 7,
    Type: 'module',
    Name: 'Module',
    Icon: 'fts-icon-locus',
    Hint: 'entry from another module in the same workspace'
  },
  Modules: {
    ID: 8,
    Type: 'modules',
    Name: 'Modules',
    Icon: 'fts-icon-locus',
    Hint: '"multiple entries with another module in the same workspace'
  },
  Location: {
    ID: 9,
    Type: 'location',
    Name: 'Location',
    Icon: 'fts-icon-map-marker',
    Hint: 'location with place name on map'
  },
  Image: {
    ID: 10,
    Type: 'image',
    Name: 'Image',
    Icon: 'fts-icon-image',
    Hint: 'single picture, photo in the format of jpg, jpeg, png, bmp and gif'
  },
  Images: {
    ID: 11,
    Type: 'images',
    Name: 'Images',
    Icon: 'fts-icon-images',
    Hint: 'multiple pictures, photos in the format of jpg, jpeg, png, bmp and gif'
  },
  File: {
    ID: 12,
    Type: 'file',
    Name: 'File',
    Icon: 'fts-icon-file',
    Hint: 'single file for example, document, spreadsheet, presentation, and pdf'
  },
  Files: {
    ID: 13,
    Type: 'files',
    Name: 'Files',
    Icon: 'fts-icon-files',
    Hint: 'multiple files for example, document, spreadsheet, presentation, and pdf'
  },
  Table: {
    ID: 14,
    Type: 'table',
    Name: 'Table',
    Icon: 'fts-icon-list-table',
    Hint: 'contains defined fields (columns) and rows. Please defined fields below'
  },
  List: {
    ID: 15,
    Type: 'list',
    Name: 'List (Alpha)',
    Icon: 'fts-icon-list-table',
    Hint: 'beta supported (list)'
  },
  Username: {
    ID: 19,
    Type: 'username',
    Name: 'Username',
    Icon: 'fts-icon-user',
    Hint: 'not supported (username)'
  },
  User: {
    ID: 20,
    Type: 'user',
    Name: 'User',
    Icon: 'fts-icon-user',
    Hint: 'entry from profile (module) in the same workspace'
  },
  Users: {
    ID: 21,
    Type: 'users',
    Name: 'Users',
    Icon: 'fts-icon-users',
    Hint: 'multiple entries from profile (module) in the same workspace'
  },
  Content: {
    ID: 22,
    Type: 'content',
    Name: 'Content',
    Icon: 'fts-icon-font-underline',
    Hint: 'formatted text with styles'
  },
  Context: {
    ID: 24,
    Type: 'context',
    Name: 'Context',
    Icon: 'fts-icon-check-square',
    Hint: 'beta supported (context)'
  },
  Email: {
    ID: 25,
    Type: 'email',
    Name: 'Email',
    Icon: 'fts-icon-envelope',
    Hint: 'email address for example: inistate@email.com'
  },
  Phone: {
    ID: 26,
    Type: 'phone-number',
    Name: 'Phone Number',
    Icon: 'fts-icon-phone',
    Hint: 'phone number with country and area code'
  },
  Select: {
    ID: 27,
    Type: 'select',
    Name: 'Select',
    Icon: 'fts-icon-menu-caret-down',
    Hint: 'dropdown selection with predefined options, please define options below'
  },
  Tag: {
    ID: 28,
    Type: 'tag',
    Name: 'Tag',
    Icon: 'fts-icon-tag',
    Hint: 'beta supported (tag)'
  },
  Signature: {
    ID: 29,
    Type: 'signature',
    Name: 'Signature',
    Icon: 'fts-icon-signature',
    Hint: 'digitally signning'
  },
  DateRange: {
    ID: 30,
    Type: 'date-range',
    Name: 'Date Range',
    Icon: 'fts-icon-calendar',
    Hint: 'not supported (date range)'
  },
  DateTimeRange: {
    ID: 31,
    Type: 'date-time-range',
    Name: 'Date Time Range',
    Icon: 'fts-icon-calendar',
    Hint: 'not supported (date time range)'
  },
  Formula: {
    ID: 32,
    Type: 'formula',
    Name: 'Formula',
    Icon: 'fts-icon-formula',
    Hint: 'not supported (formula)'
  },
  URL: {
    ID: 33,
    Type: 'url',
    Name: 'URL',
    Icon: 'fts-icon-link',
    Hint: 'web page links, starts with https://'
  },
  Form: {
    ID: 35,
    Type: 'form',
    Name: 'Form',
    Icon: 'fts-icon-form'
  },
  TableRow: {
    ID: 36,
    Type: 'table-row',
    Name: 'Table Row',
    Icon: 'fts-icon-table-row',
  },
  Unknown: {
    ID: 37,
    Type: 'unknown',
    Name: 'Unknown',
    Icon: 'fts-icon-unknown',
  }
}
/* listing */
export const Listing_Max_Total_Entries = 1000;
export const Lite_Listing_Pagination_Total_Items_Threshold = 200;
export const Export_Direct_Download_Threshold = 1000;